import { getStore } from '../store/store';
import type { TeamsSDKState } from '../store/schema/TeamsClientState';

export default function getSdkState(): TeamsSDKState {
    return getStore().sdkState;
}
